import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

function AiTrainingSection({ aiTrainingOptOut, accountId, onUpdate }) {
  const { t } = useTranslation('settings')
  const [optOut, setOptOut] = useState(aiTrainingOptOut)
  const [saving, setSaving] = useState(false)

  const handleToggle = useCallback(async () => {
    if (!accountId) return

    const newValue = !optOut
    setOptOut(newValue) // optimistic

    setSaving(true)
    try {
      const { api } = await import('../../services/api')
      await api.updateBrandSettings(accountId, { ai_training_opt_out: newValue })
      onUpdate?.()
    } catch (error) {
      console.error('Failed to update AI training preference:', error)
      setOptOut(!newValue) // revert
    } finally {
      setSaving(false)
    }
  }, [optOut, accountId, onUpdate])

  return (
    <div>
      <h3 className="text-base font-semibold text-gray-900 mb-1">
        {t('aiTraining.title')}
      </h3>
      <p className="text-sm text-gray-500 mb-4">
        {t('aiTraining.description')}
      </p>

      <label className="flex items-start cursor-pointer group">
        <div className="relative inline-flex items-center">
          <input
            type="checkbox"
            checked={!optOut}
            onChange={handleToggle}
            disabled={saving}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-primary-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-600 peer-disabled:opacity-50" />
        </div>
        <div className="ml-3">
          <span className="text-sm font-medium text-gray-900 group-hover:text-gray-700">
            {t('aiTraining.label')}
          </span>
          <p className="text-xs text-gray-500 mt-0.5">
            {optOut
              ? t('aiTraining.disabled')
              : t('aiTraining.enabled')}
          </p>
        </div>
      </label>
    </div>
  )
}

export default AiTrainingSection
